/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r3'">R3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">NAT/PAT on R2 — ACL NAT, e0/0 outside</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/9</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: <code>ping 192.168.1.1</code> from R3</p>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">NTP — R1 master (stratum 1), R2 client</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1 — exec mode first</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R1Items" :key="'t2r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2R2Items" :key="'t2r2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: <code>show clock</code> on R2</p>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">DHCP pool NETPOOL on R1, R3 e0/2 gets IP</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/5</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task3R1Items" :key="'t3r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R3</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task3R3Items" :key="'t3r3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r3Completion[item.key])"></div>
                  <code class="text-base" :class="r3Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: <code>show ip interface brief</code> on R3</p>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">SSH on R3 — netadmin, RSA 1024, SSHv2</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/5</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R3</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r3Completion[item.key])"></div>
                  <code class="text-base" :class="r3Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: <code>ssh -l netadmin 10.1.3.11</code> from R1</p>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ saveProgress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rk in ['r1','r2','r3']" :key="'s-'+rk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(rk).saved)"></div>
                    <code class="text-base" :class="getComp(rk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r3'" key="r3" id="r3_terminal" :commands="r3Commands" :prompt="r3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R3" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the checklist. Use ping/show/ssh to verify. Note: "clock set" requires exec mode (type "end" first).';

const mkCommands = (rk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(rk),
  configure:  (x) => vm.iosConfigure(rk, x),
  conf:       (x) => vm.iosConfigure(rk, x),
  interface:  (x) => vm.iosInterface(rk, x),
  int:        (x) => vm.iosInterface(rk, x),
  ip:         (x) => vm.iosIp(rk, x),
  permit:     (x) => vm.iosPermit(rk, x),
  network:    (x) => vm.iosNetwork(rk, x),
  ntp:        (x) => vm.iosNtp(rk, x),
  clock:      (x) => vm.iosClock(rk, x),
  username:   (x) => vm.iosUsername(rk, x),
  line:       (x) => vm.iosLine(rk, x),
  login:      (x) => vm.iosLogin(rk, x),
  transport:  (x) => vm.iosTransport(rk, x),
  crypto:     (x) => vm.iosCrypto(rk, x),
  ping:       (x) => vm.iosPing(rk, x),
  ssh:        (x) => vm.iosSsh(rk, x),
  show:       (x) => vm.iosShow(rk, x),
  sh:         (x) => vm.iosShow(rk, x),
  exit:       () => vm.iosExit(rk),
  end:        () => vm.iosEnd(rk),
  copy:       (x) => vm.iosCopy(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/IP_Services_Sim.png',
      sel: 'r2',
      totalScore: 0,

      r1: { mode: 'exec', currentIf: null },
      r2: { mode: 'exec', currentIf: null },
      r3: { mode: 'exec', currentIf: null },

      // r1(6) + r2(11) + r3(8) = 25 total
      r1Completion: { clockSet: false, ntpMaster: false, dhcpPool: false, dhcpNetwork: false, dhcpExcluded: false, saved: false },
      r2Completion: { aclCreated: false, acePermit1: false, acePermit2: false, acePermit3: false, e01If: false, natInside: false, e00If: false, natOutside: false, natOverload: false, ntpClient: false, saved: false },
      r3Completion: { e02If: false, ipAddrDhcp: false, lineVty: false, transportSSH: false, loginLocal: false, username: false, cryptoKey: false, saved: false },

      r1Commands: null, r2Commands: null, r3Commands: null,

      task1Items: [
        { key: 'aclCreated',  label: 'ip access-list standard NAT' },
        { key: 'acePermit1',  label: 'permit 10.2.3.3' },
        { key: 'acePermit2',  label: 'permit 192.168.3.1' },
        { key: 'acePermit3',  label: 'permit 10.1.3.11' },
        { key: 'e01If',       label: 'interface e0/1' },
        { key: 'natInside',   label: 'ip nat inside' },
        { key: 'e00If',       label: 'interface e0/0' },
        { key: 'natOutside',  label: 'ip nat outside' },
        { key: 'natOverload', label: 'ip nat inside source list NAT interface e0/0 overload' },
      ],
      task2R1Items: [
        { key: 'clockSet',  label: 'clock set 00:00:00 January 1 2019' },
        { key: 'ntpMaster', label: 'ntp master 1' },
      ],
      task2R2Items: [
        { key: 'ntpClient', label: 'ntp server 10.1.3.1' },
      ],
      task3R1Items: [
        { key: 'dhcpPool',     label: 'ip dhcp pool NETPOOL' },
        { key: 'dhcpNetwork',  label: 'network 10.1.3.0 255.255.255.0' },
        { key: 'dhcpExcluded', label: 'ip dhcp excluded-address 10.1.3.1 10.1.3.10' },
      ],
      task3R3Items: [
        { key: 'e02If',      label: 'interface e0/2' },
        { key: 'ipAddrDhcp', label: 'ip address dhcp' },
      ],
      task4Items: [
        { key: 'lineVty',      label: 'line vty 0 4' },
        { key: 'transportSSH', label: 'transport input ssh' },
        { key: 'loginLocal',   label: 'login local' },
        { key: 'username',     label: 'username netadmin password N3t4ccess' },
        { key: 'cryptoKey',    label: 'crypto key generate rsa modulus 1024' },
      ],
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'dhcp-config') return 'R1(dhcp-config)#';
      if (m === 'config-if')   return 'R1(config-if)#';
      if (m === 'config')      return 'R1(config)#';
      return 'R1#';
    },
    r2Prompt() {
      const m = this.r2.mode;
      if (m === 'config-std-nacl') return 'R2(config-std-nacl)#';
      if (m === 'config-if')       return 'R2(config-if)#';
      if (m === 'config')          return 'R2(config)#';
      return 'R2#';
    },
    r3Prompt() {
      const m = this.r3.mode;
      if (m === 'config-line') return 'R3(config-line)#';
      if (m === 'config-if')   return 'R3(config-if)#';
      if (m === 'config')      return 'R3(config)#';
      return 'R3#';
    },

    task1Progress() {
      const c = this.r2Completion;
      return [c.aclCreated, c.acePermit1, c.acePermit2, c.acePermit3, c.e01If, c.natInside, c.e00If, c.natOutside, c.natOverload].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 9; },

    task2Progress() {
      return [this.r1Completion.clockSet, this.r1Completion.ntpMaster, this.r2Completion.ntpClient].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 3; },

    task3Progress() {
      const c1 = this.r1Completion, c3 = this.r3Completion;
      return [c1.dhcpPool, c1.dhcpNetwork, c1.dhcpExcluded, c3.e02If, c3.ipAddrDhcp].filter(Boolean).length;
    },
    task3Done() { return this.task3Progress === 5; },

    task4Progress() {
      const c = this.r3Completion;
      return [c.lineVty, c.transportSSH, c.loginLocal, c.username, c.cryptoKey].filter(Boolean).length;
    },
    task4Done() { return this.task4Progress === 5; },

    saveProgress() {
      return [this.r1Completion.saved, this.r2Completion.saved, this.r3Completion.saved].filter(Boolean).length;
    },
    saveDone() { return this.saveProgress === 3; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
    this.r3Commands = mkCommands('r3', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    normalizeIf(ifStr) {
      return (ifStr||'').toLowerCase()
        .replace(/^gigabitethernet/,'').replace(/^fastethernet/,'').replace(/^ethernet/,'')
        .replace(/^gi(?=\d)/,'').replace(/^fa(?=\d)/,'').replace(/^e(?=\d)/,'').replace(/^g(?=\d)/,'')
        .trim();
    },
    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion, this.r3Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      if (score >= 25) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosConfigure(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[rk].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      const s = this[rk];
      if (['config-if','config-line','config-std-nacl','dhcp-config'].includes(s.mode)) {
        s.mode = 'config'; s.currentIf = null;
      } else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },
    iosEnd(rk) { this[rk].mode = 'exec'; this[rk].currentIf = null; return createStdout(''); },

    iosInterface(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config' && s.mode !== 'config-if') return createStderr('% Must be in configuration mode');
      let ifArg = String(x._[1]||'');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      if (ifArg.toLowerCase() === 'vlan' && x._[2]) ifArg = 'vlan' + x._[2];
      const ifNorm = this.normalizeIf(ifArg) || ifArg.toLowerCase();
      s.mode = 'config-if'; s.currentIf = ifNorm;
      const c = this[rk + 'Completion'];
      if (rk === 'r2') {
        if (ifNorm === '0/0' && !c.e00If) { c.e00If = true; this.updateScore(); }
        if (ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      }
      if (rk === 'r3' && ifNorm === '0/2' && !c.e02If) { c.e02If = true; this.updateScore(); }
      return createStdout('');
    },

    iosIp(rk, x) {
      const s = this[rk];
      const sub1=(x._[1]||'').toLowerCase(), sub2=(x._[2]||'').toLowerCase(), sub3=(x._[3]||'').toLowerCase();
      const c = this[rk + 'Completion'];

      if (s.mode === 'config') {
        // ip access-list standard NAT
        if (sub1 === 'access-list' && sub2 === 'standard') {
          const aclName = (x._[3]||'').toUpperCase();
          if (rk === 'r2' && aclName === 'NAT') {
            s.mode = 'config-std-nacl';
            if (!c.aclCreated) { c.aclCreated = true; this.updateScore(); }
            return createStdout(this.guide('Standard named ACL "NAT" created. Standard ACLs match only by source address. Mode is now R2(config-std-nacl)#. → Enter permit statements.'));
          }
          return createStdout('');
        }
        // ip nat inside source list NAT interface e0/0 overload
        if (sub1 === 'nat' && sub2 === 'inside' && sub3 === 'source') {
          const list = (x._[5]||'').toUpperCase(), ifArg = String(x._[7]||''), ovl = (x._[8]||'').toLowerCase();
          if (rk === 'r2' && list === 'NAT' && this.normalizeIf(ifArg) === '0/0' && ovl === 'overload' && !c.natOverload) {
            c.natOverload = true; this.updateScore();
            return createStdout(this.guide('PAT configured on R2 — R3 source addresses matching ACL NAT are translated to R2 e0/0\'s IP. → Verify: on R3 run "end" then "ping 192.168.1.1".'));
          }
          return createStdout('');
        }
        // ip dhcp pool NETPOOL
        if (sub1 === 'dhcp' && sub2 === 'pool') {
          const poolName = (x._[3]||'').toUpperCase();
          if (rk === 'r1' && poolName === 'NETPOOL') {
            s.mode = 'dhcp-config';
            if (!c.dhcpPool) { c.dhcpPool = true; this.updateScore(); }
            return createStdout(this.guide('DHCP pool NETPOOL created. Mode is now R1(dhcp-config)#. → "network 10.1.3.0 255.255.255.0".'));
          }
          return createStdout('');
        }
        // ip dhcp excluded-address 10.1.3.1 10.1.3.10
        if (sub1 === 'dhcp' && sub2 === 'excluded-address') {
          const start = String(x._[3]||''), end = String(x._[4]||'');
          if (rk === 'r1' && start === '10.1.3.1' && end === '10.1.3.10' && !c.dhcpExcluded) {
            c.dhcpExcluded = true; this.updateScore();
            return createStdout(this.guide('Addresses 10.1.3.1–10.1.3.10 excluded. R3 will receive 10.1.3.11 (first available). → On R3: "interface e0/2" then "ip address dhcp".'));
          }
          return createStdout('');
        }
        return createStderr('% Invalid input detected');
      }

      if (s.mode === 'config-if') {
        // ip nat inside / ip nat outside
        if (sub1 === 'nat') {
          if (sub2 === 'inside' && sub3 !== 'source') {
            if (rk === 'r2' && s.currentIf === '0/1' && !c.natInside) {
              c.natInside = true; this.updateScore();
              return createStdout(this.guide('R2 e0/1 marked as NAT inside (LAN-facing). → "exit" then "interface e0/0" then "ip nat outside".'));
            }
            return createStdout('');
          }
          if (sub2 === 'outside') {
            if (rk === 'r2' && s.currentIf === '0/0' && !c.natOutside) {
              c.natOutside = true; this.updateScore();
              return createStdout(this.guide('R2 e0/0 marked as NAT outside (ISP-facing). → "exit" then "ip nat inside source list NAT interface e0/0 overload".'));
            }
            return createStdout('');
          }
        }
        // ip address dhcp
        if (sub1 === 'address' && sub2 === 'dhcp') {
          if (rk === 'r3' && s.currentIf === '0/2' && !c.ipAddrDhcp) {
            c.ipAddrDhcp = true; this.updateScore();
            return createStdout(this.guide('R3 e0/2 set to DHCP. R3 will request an IP from R1\'s NETPOOL — should receive 10.1.3.11. → Verify: "exit" "exit" then "show ip interface brief".'));
          }
          return createStdout('');
        }
        return createStderr('% Invalid input detected');
      }

      return createStderr('% Invalid input detected');
    },

    iosPermit(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-std-nacl') return createStderr('% Must be in standard ACL configuration mode — type "ip access-list standard NAT" first');
      const c = this[rk + 'Completion'];
      const addr = String(x._[1]||'');
      if (rk === 'r2') {
        if (addr === '10.2.3.3' && !c.acePermit1) {
          c.acePermit1 = true; this.updateScore();
          return createStdout(this.guide('ACE: permit 10.2.3.3 (R3 primary address). → "permit 192.168.3.1".'));
        }
        if (addr === '192.168.3.1' && !c.acePermit2) {
          c.acePermit2 = true; this.updateScore();
          return createStdout(this.guide('ACE: permit 192.168.3.1 (R3 loopback/secondary). → "permit 10.1.3.11".'));
        }
        if (addr === '10.1.3.11' && !c.acePermit3) {
          c.acePermit3 = true; this.updateScore();
          return createStdout(this.guide('ACE: permit 10.1.3.11 (R3 DHCP address). All R3 source IPs are permitted. → "exit" then configure NAT interfaces.'));
        }
      }
      return createStdout('');
    },

    iosNetwork(rk, x) {
      const s = this[rk];
      if (s.mode !== 'dhcp-config') return createStderr('% Must be in DHCP pool configuration mode — type "ip dhcp pool NETPOOL" first');
      const subnet = String(x._[1]||''), mask = String(x._[2]||'');
      const c = this[rk + 'Completion'];
      if (rk === 'r1' && subnet === '10.1.3.0' && mask === '255.255.255.0' && !c.dhcpNetwork) {
        c.dhcpNetwork = true; this.updateScore();
        return createStdout(this.guide('Network 10.1.3.0/24 assigned to pool NETPOOL. → "exit" then "ip dhcp excluded-address 10.1.3.1 10.1.3.10".'));
      }
      return createStdout('');
    },

    iosNtp(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const sub1 = (x._[1]||'').toLowerCase();
      const c = this[rk + 'Completion'];
      if (sub1 === 'master' && rk === 'r1' && !c.ntpMaster) {
        c.ntpMaster = true; this.updateScore();
        return createStdout(this.guide('R1 configured as NTP master (stratum 1). R1 will serve time to NTP clients. → Configure R2: "ntp server 10.1.3.1".'));
      }
      if (sub1 === 'source-interface' || sub1 === 'source') {
        return createStdout(this.guide('Note: "ntp source-interface" is not supported in Packet Tracer — ignoring. → Configure NTP client on R2.'));
      }
      if (sub1 === 'server' && rk === 'r2') {
        const addr = String(x._[2]||'');
        if (addr === '10.1.3.1' && !c.ntpClient) {
          c.ntpClient = true; this.updateScore();
          return createStdout(this.guide('R2 NTP client pointing to 10.1.3.1 (R1 E0/2). → Verify with "show clock" on R2 — should show Jan 1 2019.'));
        }
      }
      return createStdout('');
    },

    iosClock(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first (clock set is a privileged EXEC command)');
      if ((x._[1]||'').toLowerCase() !== 'set') return createStderr('% Invalid input detected');
      const time  = String(x._[2]||'');
      const month = (x._[3]||'').toLowerCase();
      const day   = String(x._[4]||'');
      const year  = String(x._[5]||'');
      const c = this[rk + 'Completion'];
      const timeOk  = time.startsWith('00:00:') || time === '0:0:0';
      const monthOk = month.startsWith('jan');
      const dayOk   = day === '1' || day === '01';
      const yearOk  = year === '2019';
      if (rk === 'r1' && timeOk && monthOk && dayOk && yearOk && !c.clockSet) {
        c.clockSet = true; this.updateScore();
        return createStdout(this.guide('R1 clock set to midnight January 1, 2019. → "configure terminal" then "ntp master 1".'));
      }
      return createStdout('');
    },

    iosUsername(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[rk + 'Completion'];
      const user    = (x._[1]||'').toLowerCase();
      const pwdKw   = (x._[2]||'').toLowerCase();
      const pwd     = String(x._[3]||'');
      if (rk === 'r3' && user === 'netadmin' && pwdKw === 'password' && pwd === 'N3t4ccess' && !c.username) {
        c.username = true; this.updateScore();
        return createStdout(this.guide('User "netadmin" created with password N3t4ccess. Note: ip domain-name is pre-configured. → "crypto key generate rsa modulus 1024".'));
      }
      return createStdout('');
    },

    iosLine(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[rk + 'Completion'];
      if (rk === 'r3' && (x._[1]||'').toLowerCase() === 'vty') {
        s.mode = 'config-line';
        if (!c.lineVty) { c.lineVty = true; this.updateScore(); }
        return createStdout(this.guide('VTY 0-4 line configuration entered. → "transport input ssh" then "login local".'));
      }
      return createStdout('');
    },

    iosLogin(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-line') return createStderr('% Must be in line configuration mode — type "line vty 0 4" first');
      const c = this[rk + 'Completion'];
      if (rk === 'r3' && (x._[1]||'').toLowerCase() === 'local' && !c.loginLocal) {
        c.loginLocal = true; this.updateScore();
        return createStdout(this.guide('VTY lines use local authentication. → "username netadmin password N3t4ccess".'));
      }
      return createStdout('');
    },

    iosTransport(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-line') return createStderr('% Must be in line configuration mode');
      const c = this[rk + 'Completion'];
      const sub2 = (x._[2]||'').toLowerCase();
      if (rk === 'r3' && (x._[1]||'').toLowerCase() === 'input' && sub2 === 'ssh' && !c.transportSSH) {
        c.transportSSH = true; this.updateScore();
        return createStdout(this.guide('VTY lines restricted to SSH only — Telnet is blocked. → "login local".'));
      }
      return createStdout('');
    },

    iosCrypto(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      if ((x._[1]||'').toLowerCase() !== 'key' || (x._[2]||'').toLowerCase() !== 'generate' || (x._[3]||'').toLowerCase() !== 'rsa') {
        return createStderr('% Invalid input detected');
      }
      const c = this[rk + 'Completion'];
      if (rk === 'r3') {
        const sub4 = (x._[4]||'').toLowerCase();
        const bits  = sub4 === 'general-keys' ? String(x._[6]||'') : String(x._[5]||'');
        if (bits === '1024' && !c.cryptoKey) {
          c.cryptoKey = true; this.updateScore();
          return createStdout(
            '% Generating 1024 bit RSA keys...<br>[OK]' +
            this.guide('RSA 1024-bit key pair generated on R3. SSH server is now active. → Verify from R1: "end" then "ssh -l netadmin 10.1.3.11".')
          );
        }
      }
      return createStdout('');
    },

    iosPing(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const target = (x._[1]||'').toLowerCase();
      if (rk === 'r3' && target === '192.168.1.1') {
        if (this.r2Completion.natOverload) {
          return createStdout(
            'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 192.168.1.1, timeout is 2 seconds:<br>.!!!!</b><br>Success rate is 80 percent (4/5)' +
            this.guide('NAT verified — R3 can reach R1\'s loopback. R2 is translating R3\'s source IP to R2\'s e0/0 address.')
          );
        }
        return createStdout('.....<br>Success rate is 0 percent (0/5)' + this.guide('Ping failed — configure NAT overload on R2 first (Task 1).'));
      }
      return createStdout('.....<br>Success rate is 0 percent (0/5)');
    },

    iosSsh(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const param = (x._[1]||'').toLowerCase(), user = String(x._[2]||''), target = String(x._[3]||'');
      if (rk === 'r1' && param === '-l' && user.toLowerCase() === 'netadmin' && target === '10.1.3.11') {
        const c = this.r3Completion;
        if (c.cryptoKey && c.transportSSH && c.loginLocal && c.username) {
          return createStdout('Password: <br>R3#' + this.guide('SSH connection to R3 successful! User "netadmin" is now logged in.'));
        }
        return createStdout('ssh: connect to host 10.1.3.11 port 22: Connection refused' + this.guide('SSH not ready on R3 — complete Task 4 first.'));
      }
      return createStdout('% Connection failed');
    },

    iosShow(rk, x) {
      const sub1=(x._[1]||'').toLowerCase(), sub2=(x._[2]||'').toLowerCase(), sub3=(x._[3]||'').toLowerCase();

      // show clock
      if (sub1 === 'clock') {
        if (this.r1Completion.ntpMaster && this.r2Completion.ntpClient) {
          return createStdout('0:0:01.60 UTC Tue Jan 1 2019' + this.guide('R2 clock synchronized with R1. Time matches January 1, 2019.'));
        }
        return createStdout('*00:00:00.000 UTC Mon Mar 1 1993' + this.guide('Clock not synchronized — configure NTP on both R1 and R2 first.'));
      }

      // show ip nat translations
      if (sub1 === 'ip' && sub2 === 'nat' && sub3 === 'translations') {
        if (this.r2Completion.natOverload) {
          return createStdout(
            'Pro&nbsp;&nbsp;Inside global&nbsp;Inside local&nbsp;&nbsp;Outside local&nbsp;&nbsp;Outside global<br>' +
            'icmp&nbsp;10.0.18.9:2&nbsp;&nbsp;&nbsp;10.2.3.3:2&nbsp;&nbsp;&nbsp;&nbsp;192.168.1.1:2&nbsp;&nbsp;192.168.1.1:2<br>' +
            'icmp&nbsp;10.0.18.9:3&nbsp;&nbsp;&nbsp;10.2.3.3:3&nbsp;&nbsp;&nbsp;&nbsp;192.168.1.1:3&nbsp;&nbsp;192.168.1.1:3' +
            this.guide('NAT translation table populated. R3 source addresses are being translated to R2\'s e0/0 IP.')
          );
        }
        return createStdout('(empty — configure NAT overload first)');
      }

      // show ip interface brief / show ip int brief
      if (sub1 === 'ip' && (sub2 === 'interface' || sub2 === 'int') && sub3 === 'brief') {
        if (rk === 'r3') {
          if (this.r3Completion.ipAddrDhcp && this.r1Completion.dhcpExcluded) {
            return createStdout(
              'Interface&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;&nbsp;Protocol<br>' +
              'Ethernet0/0&nbsp;&nbsp;10.2.3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;Manual&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
              'Ethernet0/2&nbsp;&nbsp;10.1.3.11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;DHCP&nbsp;&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up' +
              this.guide('R3 e0/2 received 10.1.3.11 via DHCP from R1\'s NETPOOL pool.')
            );
          }
          return createStdout(
            'Interface&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;&nbsp;Protocol<br>' +
            'Ethernet0/0&nbsp;&nbsp;10.2.3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;Manual&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
            'Ethernet0/2&nbsp;&nbsp;unassigned&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;unset&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up' +
            this.guide('R3 e0/2 has no IP yet — configure DHCP pool on R1 and set "ip address dhcp" on R3 e0/2.')
          );
        }
        return createStderr('% Invalid input detected');
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const c = this[rk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${rk.toUpperCase()} saved. ` + (this.saveDone ? '✓ All routers saved — simulation complete!' : '→ Save remaining routers.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal, #r3_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>
